import React, { ReactNode } from 'react';
import errorImg from "./assets/images/error.jpg"

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

// Custom Error Image component
export const ErrorImage = () => {
  return (
    <div className="flex flex-col items-center justify-center p-6 text-center">
      <img src={errorImg}/>
    </div>
  );
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    this.setState({ errorInfo });
    // You can also log to an error reporting service here
  }

  render(): ReactNode {
    const { hasError, error } = this.state;

    if (hasError) {
      return this.props.fallback || (
        <div className="p-6 text-center">
          <ErrorImage />
          {error && (
            <pre className="mt-6 p-4 bg-gray-100 rounded text-sm text-gray-700 overflow-auto">
              {error.toString()}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}


export const RouteErrorComponent = () => {
  return (
    <ErrorBoundary>
      {(() => { throw new Error("Forced error"); })()}
      <div>This will never render</div>
    </ErrorBoundary>
);
};